export const DayParts = {
  BeforeOpen: 'Before Open',
  AMOpenShift: 'AM - Open Shift',
  PMMidShift: 'PM - Mid Shift',
  PMCloseShift: 'PM - Close Shift',
  Overnight: 'Overnight',
  AfterClose: 'After Close'
} as const

export type DayPart = (typeof DayParts)[keyof typeof DayParts]

export const Frequencies = {
  Weekly: 'Weekly',
  Fortnightly: 'Fortnightly',
  Monthly: 'Monthly',
  Quarterly: 'Quarterly'
} as const

export type Frequency = (typeof Frequencies)[keyof typeof Frequencies]

export const DaysOfWeek = {
  MONDAY: 'Monday',
  TUESDAY: 'Tuesday',
  WEDNESDAY: 'Wednesday',
  THURSDAY: 'Thursday',
  FRIDAY: 'Friday',
  SATURDAY: 'Saturday',
  SUNDAY: 'Sunday'
} as const

export type DayOfWeek = (typeof DaysOfWeek)[keyof typeof DaysOfWeek]

export const Statuses = {
  SCHEDULED: 'Scheduled',
  ASSIGNED: 'Assigned',
  COMPLETED: 'Completed',
  OVERDUE: 'Overdue',
  SIGNEDOFF: 'SignedOff',
  DEACTIVATED: 'Deactivated'
} as const

export type Status = (typeof Statuses)[keyof typeof Statuses]
